/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const NoticeOrderListPage = lazyLoad(
  () => import('./index'),
  module => module.NoticeOrderListPage
);
